import React from 'react';
import progressStyles from './ACWTimerProgress.module.css';
import { formatAcwTime } from './useAcwCountdown';

interface AcwTimerProgressProps {
  remaining: number;
  isWarning: boolean;
  progressPercent: number;
}

export function AcwTimerProgress({ remaining, isWarning, progressPercent }: AcwTimerProgressProps) {
  return (
    <div className={progressStyles.timerSectionCompact}>
      <div className={progressStyles.progressRingSmall}>
        <svg viewBox="0 0 100 100" className={progressStyles.progressSvg}>
          <circle cx="50" cy="50" r="45" fill="none" stroke="#e5e7eb" strokeWidth="8" />
          <circle
            cx="50"
            cy="50"
            r="45"
            fill="none"
            stroke={isWarning ? '#BB0000' : '#0070F2'}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={`${2 * Math.PI * 45}`}
            strokeDashoffset={`${2 * Math.PI * 45 * (1 - progressPercent / 100)}`}
            transform="rotate(-90 50 50)"
            className={progressStyles.progressCircle}
          />
        </svg>
        <div className={progressStyles.timerDisplaySmall}>
          <span
            className={`${progressStyles.timeSmall} ${isWarning ? progressStyles.warning : ''}`}
          >
            {formatAcwTime(remaining)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default AcwTimerProgress;
